module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-left-quote-fill-79826b53.svg";